module.exports = __webpack_public_path__ + "img/met-logo.57e433f0.svg";